// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const SUC_MOD_APP_REWARD_CONFIG = 'Modified app reward configuration.';
export const ERR_MOD_APP_REWARD_CONFIG = 'Failed to modify app reward configuration';
export const SUC_ARC_APP_REWARD_CONFIG = 'Deleted app reward configuration.';
export const ERR_ARC_APP_REWARD_CONFIG = 'Failed to delete app reward configuration';

// Registry operator mutations
export const ERR_ARC_OP_CONF = 'Failed to archive operator configuration';
export const ERR_CRE_OP_CONF = 'Failed to create operator configuration';
export const ERR_GRA_UPG_CONS = 'Failed to grant upgrade consent';
export const ERR_MOD_OP_CONF = 'Failed to modify operator configuration';
export const SUC_ARC_OP_CONF = 'Archived operator configuration.';
export const SUC_CRE_OP_CONF = 'Created operator configuration.';
export const SUC_GRA_UPG_CONS = 'Granted upgrade consent.';
export const SUC_MOD_OP_CONF = 'Modified operator configuration.';

// Registry registrar service mutations
export const ERR_ACC_REGISTRAR_SVC = 'Failed to accept registry registrar service request';
export const ERR_CAN_REGISTRAR_SVC = 'Failed to cancel registry registrar service request';
export const ERR_REJ_REGISTRAR_SVC = 'Failed to reject registry registrar service request';
export const ERR_REQ_REGISTRAR_SVC = 'Failed to request registry registrar service';
export const ERR_TER_REGISTRAR_SVC = 'Failed to terminate registry registrar service';
export const SUC_ACC_REGISTRAR_SVC = 'Accepted registry registrar service request.';
export const SUC_CAN_REGISTRAR_SVC = 'Cancelled registry registrar service request.';
export const SUC_REJ_REGISTRAR_SVC = 'Rejected registry registrar service request.';
export const SUC_REQ_REGISTRAR_SVC = 'Requested registry registrar service.';
export const SUC_TER_REGISTRAR_SVC = 'Terminated registry registrar service.';

// Registry registrar mutations
export const ERR_PAUSE_INST_CONF = 'Failed to pause instrument configuration';
export const ERR_UNPAUSE_INST_CONF = 'Failed to unpause instrument configuration';
export const ERR_ENABLE_FRACTIONAL_SUPPORT = 'Failed to enable fractional support';
export const ERR_DISABLE_FRACTIONAL_SUPPORT = 'Failed to disable fractional support';
export const ERR_DISABLE_TRANSFERS_INST_CONF =
  'Failed to disable transfers on instrument configuration';
export const ERR_ENABLE_TRANSFERS_INST_CONF =
  'Failed to enable transfers on instrument configuration';
export const ERR_ARC_INST_CONF = 'Failed to archive instrument configuration';
export const ERR_CRE_INST_CONF = 'Failed to create instrument configuration';
export const ERR_MOD_INST_CONF = 'Failed to modify instrument configuration';
export const SUC_PAUSE_INST_CONF = 'Paused instrument configuration.';
export const SUC_UNPAUSE_INST_CONF = 'Unpaused instrument configuration.';
export const SUC_ENABLE_FRACTIONAL_SUPPORT = 'Enabled fractional support.';
export const SUC_DISABLE_FRACTIONAL_SUPPORT = 'Disabled fractional support.';
export const SUC_DISABLE_TRANSFERS_INST_CONF = 'Disabled transfers on instrument configuration.';
export const SUC_ENABLE_TRANSFERS_INST_CONF = 'Enabled transfers on instrument configuration.';
export const SUC_ARC_INST_CONF = 'Archived instrument configuration.';
export const SUC_CRE_INST_CONF = 'Created instrument configuration.';
export const SUC_MOD_INST_CONF = 'Modified instrument configuration.';
export const SUC_WITHDRAW_ALLOCATION = 'Withdrew allocation.';
export const ERR_WITHDRAW_ALLOCATION = 'Failed to withdraw allocation';
export const SUC_ACCEPT_REGISTRAR_REQUEST = 'Accepted registrar service request.';
export const ERR_ACCEPT_REGISTRAR_REQUEST =
  'Failed to accept registrar service request. Is your wallet connected?';

// Registry holder mutations
export const ERR_FREEZE = 'Failed to freeze position';
export const ERR_UNFREEZE = 'Failed to freeze position';
export const ERR_REQ_BURN = 'Failed to request burn';
export const ERR_REQ_MINT = 'Failed to request mint';
export const SUC_REQ_BURN = 'Requested burn.';
export const SUC_INSTRUCT_XFER = 'Instructed transfer.';
export const ERR_INSTRUCT_XFER = 'Failed to instruct transfer';
export const SUC_CLAWBACK = 'Clawed back holdings.';
export const ERR_CLAWBACK = 'Failed to claw back holdings';
export const SUC_ACC_INSTRUCT_XFER = 'Accepted instructed transfer.';
export const ERR_ACC_INSTRUCT_XFER = 'Failed to accept instructed transfer';
export const ERR_ACC_INSTRUCT_XFER_FAILED =
  'Transfer was accepted but failed to complete. The transfer offer has been cancelled.';
export const SUC_WITHDRAW_INSTRUCT_XFER = 'Withdrew transfer offer instructions.';
export const ERR_WITHDRRAW_INSTRUCT_XFER = 'Failed to withdraw instructed transfer offer';
export const SUC_REJECT_INSTRUCT_XFER = 'Rejected instructed transfer.';
export const ERR_REJECT_INSTRUCT_XFER = 'Failed to reject instructed transfer';
export const SUC_FREEZE = 'Froze position.';
export const SUC_UNFREEZE = 'Unfroze position.';
export const SUC_REQ_MINT = 'Requested mint.';
export const SUC_CREATE_APP_REWARD_CONFIG = 'Created app reward configuration.';
export const ERR_CREATE_APP_REWARD_CONFIG = 'Failed to create app reward configuration';

// Coin mutations
export const ERR_TAP_COIN = 'Failed to tap coin';
export const SUC_TAP_COIN = 'Tapped coin.';

// Allocation Instruction
export const SUC_CREATE_ALLOCATION = 'Created allocation.';
export const ERR_CREATE_ALLOCATION = 'Failed to create allocation';

// Request Participant Onboarding
export const ERR_REQ_PARTICIPANT_ONBOARDING =
  'Failed to request participant onboarding. Is your wallet connected?';
export const SUC_REQ_PARTICIPANT_ONBOARDING = 'Requested participant onboarding.';
export const ERR_ACC_PARTICIPANT_ONBOARDING_REQ =
  'Failed to accept participant onboarding request. Is your wallet connected?';
export const SUC_ACC_PARTICIPANT_ONBOARDING_REQ = 'Accepted participant onboarding request.';
export const ERR_REJ_PARTICIPANT_ONBOARDING_REQ =
  'Failed to reject participant onboarding request. Is your wallet connected?';
export const SUC_REJ_PARTICIPANT_ONBOARDING_REQ = 'Rejected participant onboarding request.';
export const ERR_CAN_PARTICIPANT_ONBOARDING_REQ =
  'Failed to cancel participant onboarding request. Is your wallet connected?';
export const SUC_CAN_PARTICIPANT_ONBOARDING_REQ = 'Cancelled participant onboarding request.';

// Request End Investor Onboarding
export const ERR_REQUEST_END_INVESTOR_ONBOARDING =
  'Failed to request end investor onboarding. Is your wallet connected?';
export const SUC_REQUEST_END_INVESTOR_ONBOARDING = 'Requested end investor onboarding.';

// Offer Participant Onboarding
export const ERR_OFFER_PARTICIPANT_ONBOARDING =
  'Failed to offer participant onboarding. Is your wallet connected?';
export const SUC_OFFER_PARTICIPANT_ONBOARDING = 'Offered participant onboarding.';

// End Investor Onboarding
export const ERR_END_INVESTOR_ONBOARDING_OFFER =
  'Failed to onboard end investor. Is your wallet connected?';
export const SUC_END_INVESTOR_ONBOARDING_OFFER = 'Onboarded end investor.';

// End Investor Offboarding
export const ERR_END_INVESTOR_OFFBOARDING =
  'Failed to offboard end investor. Is your wallet connected?';
export const SUC_END_INVESTOR_OFFBOARDING = 'Offboarded end investor.';

// Participant Offboarding
export const ERR_OFFBOARD_PARTICIPANT = 'Failed to offboard participant';
export const SUC_OFFBOARD_PARTICIPANT = 'Offboarded participant.';

// Registrar Offboarding
export const ERR_OFFBOARD_REGISTRAR = 'Failed to offboard registrar';
export const SUC_OFFBOARD_REGISTRAR = 'Offboarded registrar.';

// Client Onboarder Offboarding
export const ERR_OFFBOARD_CLIENT_ONBOARDER = 'Failed to offboard client onboarder';
export const SUC_OFFBOARD_CLIENT_ONBOARDER = 'Offboarded client onboarder.';

// Accept Compliance Service Request
export const ERR_ACC_COMPLIANCE_SVC =
  'Failed to accept compliance service request. Is your wallet connected?';
export const SUC_ACC_COMPLIANCE_SVC = 'Accepted compliance service request.';

// Create Compliance Service Request
export const SUC_CREATE_COMPLIANCE_SERVICE_REQUEST = 'Created compliance service request.';
export const ERR_CREATE_COMPLIANCE_SERVICE_REQUEST =
  'Failed to create compliance service request. Is your wallet connected?';

// Reject Compliance Service Request
export const ERR_REJ_COMPLIANCE_SVC =
  'Failed to reject compliance service request. Is your wallet connected?';
export const SUC_REJ_COMPLIANCE_SVC = 'Rejected compliance service request.';

// Cancel Compliance Service Request
export const ERR_CAN_COMPLIANCE_SVC =
  'Failed to cancel compliance service request. Is your wallet connected?';
export const SUC_CAN_COMPLIANCE_SVC = 'Cancelled compliance service request.';

// Accept Client Onboarder Service Request
export const ERR_ACC_CLIENT_ONBOARDER_SVC =
  'Failed to accept client onboarder service request. Is your wallet connected?';
export const SUC_ACC_CLIENT_ONBOARDER_SVC = 'Accepted client onboarder service request.';

// Reject Client Onboarder Service Request
export const ERR_REJ_CLIENT_ONBOARDER_SVC =
  'Failed to reject client onboarder service request. Is your wallet connected?';
export const SUC_REJ_CLIENT_ONBOARDER_SVC = 'Rejected client onboarder service request.';

// Cancel Client Onboarder Service Request
export const ERR_CAN_CLIENT_ONBOARDER_SVC =
  'Failed to cancel client onboarder service request. Is your wallet connected?';
export const SUC_CAN_CLIENT_ONBOARDER_SVC = 'Cancelled client onboarder service request.';
// Accept End Investor Onboarding Offer
export const ERR_ACC_END_INVESTOR_ONBOARDING_OFFER =
  'Failed to accept end investor onboarding offer. Is your wallet connected?';
export const SUC_ACC_END_INVESTOR_ONBOARDING_OFFER = 'Accepted end investor onboarding offer.';

// Reject End Investor Onboarding Offer
export const ERR_REJ_END_INVESTOR_ONBOARDING_OFFER =
  'Failed to reject end investor onboarding offer. Is your wallet connected?';
export const SUC_REJ_END_INVESTOR_ONBOARDING_OFFER = 'Rejected end investor onboarding offer.';

// Cancel End Investor Onboarding Offer
export const ERR_CAN_END_INVESTOR_ONBOARDING_OFFER =
  'Failed to cancel end investor onboarding offer. Is your wallet connected?';
export const SUC_CAN_END_INVESTOR_ONBOARDING_OFFER = 'Cancelled end investor onboarding offer.';

// Cancel End Investor Onboarding Request
export const ERR_CAN_END_INVESTOR_ONBOARDING_REQUEST =
  'Failed to cancel end investor onboarding request. Is your wallet connected?';
export const SUC_CAN_END_INVESTOR_ONBOARDING_REQUEST = 'Cancelled end investor onboarding request.';

// Approve End Investor Onboarding Request
export const ERR_ACC_END_INVESTOR_ONBOARDING_REQUEST =
  'Failed to approve end investor onboarding request. Is your wallet connected?';
export const SUC_ACC_END_INVESTOR_ONBOARDING_REQUEST = 'Approved end investor onboarding request.';

// Reject End Investor Onboarding Request
export const ERR_REJ_END_INVESTOR_ONBOARDING_REQUEST =
  'Failed to reject end investor onboarding request. Is your wallet connected?';
export const SUC_REJ_END_INVESTOR_ONBOARDING_REQUEST = 'Rejected end investor onboarding request.';

// Client Onboarder Service
export const SUC_CREATE_CLIENT_ONBOARDER_SERVICE_REQUEST =
  'Created client onboarder service request.';
export const ERR_CREATE_CLIENT_ONBOARDER_SERVICE_REQUEST =
  'Failed to create client onboarder service request. Is your wallet connected?';

// Terminate Compliance Service
export const SUC_TER_COMPLIANCE_SVC = 'Terminated compliance service.';
export const ERR_TER_COMPLIANCE_SVC = 'Failed to terminate compliance service';

// Accept Instrument Security Control Service Request
export const ERR_ACC_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Failed to accept instrument security control service request. Is your wallet connected?';
export const SUC_ACC_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Accepted instrument security control service request.';

// Create Instrument Security Control Service Request
export const SUC_CREATE_INSTRUMENT_SECURITY_CONTROL_SERVICE_REQUEST =
  'Created instrument security control service request.';
export const ERR_CREATE_INSTRUMENT_SECURITY_CONTROL_SERVICE_REQUEST =
  'Failed to create instrument security control service request. Is your wallet connected?';

// Reject Instrument Security Control Service Request
export const ERR_REJ_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Failed to reject instrument security control service request. Is your wallet connected?';
export const SUC_REJ_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Rejected instrument security control service request.';

// Cancel Instrument Security Control Service Request
export const ERR_CAN_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Failed to cancel instrument security control service request. Is your wallet connected?';
export const SUC_CAN_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Cancelled instrument security control service request.';

// Terminate Instrument Security Control Service
export const SUC_TER_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Terminated instrument security control service.';
export const ERR_TER_INSTRUMENT_SECURITY_CONTROL_SVC =
  'Failed to terminate instrument security control service';

// Terminate Client Onboarder Service
export const SUC_TER_CLIENT_ONBOARDER_SVC = 'Terminated client onboarder service.';
export const ERR_TER_CLIENT_ONBOARDER_SVC = 'Failed to terminate client onboarder service';

// Create Request Compliance Service
export const SUC_CREATE_REQUEST_REGISTRAR_SERVICE = 'Created registrar service request.';
export const ERR_CREATE_REQUEST_REGISTRAR_SERVICE =
  'Failed to create registrar service request. Is your wallet connected?';

// Create Allow List
export const SUC_CRE_ALLOW_LIST = 'Created allow list.';
export const ERR_CRE_ALLOW_LIST = 'Failed to create allow list. Is your wallet connected?';

// Allow List Instrument Operations
export const SUC_ATTACH_INSTRUMENTS = 'Attached instruments to allow list.';
export const ERR_ATTACH_INSTRUMENTS =
  'Failed to attach instruments to allow list. Is your wallet connected?';
export const SUC_DETACH_INSTRUMENTS = 'Detached instruments from allow list.';
export const ERR_DETACH_INSTRUMENTS =
  'Failed to detach instruments from allow list. Is your wallet connected?';
export const SUC_ADD_ISSUER_ROLES = 'Added issuer roles to allow list for instrument.';
export const ERR_ADD_ISSUER_ROLES =
  'Failed to add issuer roles to allow list for instrument. Is your wallet connected?';
export const SUC_REMOVE_ISSUER_ROLES = 'Removed issuer roles from allow list.';
export const ERR_REMOVE_ISSUER_ROLES =
  'Failed to remove issuer roles from allow list. Is your wallet connected?';
export const ERR_NO_ISSUER_ROLES_TO_REMOVE = 'Instrument does not exist';

export const ERR_INSTRUMENT_DOES_NOT_EXIST_OR_IS_UNAVAILABLE =
  'Instrument does not exist or is unavailable for this allowlist';

export const ERR_INSTRUMENT_DOES_NOT_EXIST_IN_ALLOW_LIST =
  'Instrument does not exist in allow list';

// Allow List Wallet Operations
export const SUC_ADD_WALLET = 'Added wallet to allow list.';
export const ERR_ADD_WALLET = 'Failed to add wallet to allow list. Is your wallet connected?';
export const ERR_ADD_WALLET_NOT_FOUND = 'Party not found or already a member of this allow list.';
export const SUC_REMOVE_WALLETS = 'Removed wallets from allow list.';
export const ERR_REMOVE_WALLETS =
  'Failed to remove wallets from allow list. Is your wallet connected?';
export const ERR_REMOVE_WALLETS_NOT_FOUND =
  'Party not found or is not a member of this allow list.';

// Deny List Wallet Operations
export const SUC_ADD_WALLET_TO_DENY_LIST = 'Added wallet to deny list.';
export const ERR_ADD_WALLET_TO_DENY_LIST =
  'Failed to add wallet to deny list. Is your wallet connected?';
export const ERR_ADD_WALLET_TO_DENY_LIST_NOT_FOUND =
  'Party not found or already a member of this deny list.';
export const SUC_REMOVE_WALLETS_FROM_DENY_LIST = 'Removed wallets from deny list.';
export const ERR_REMOVE_WALLETS_FROM_DENY_LIST =
  'Failed to remove wallets from deny list. Is your wallet connected?';
